<template>
    <div id="main-wrapper" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
       <AdminNavbar/>

        <div class="page-title">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <h2 class="ipt-title">{{$t('Welcome!')}}</h2>
                        <span class="ipn-subtitle">{{ $t('Welcome To Your Account') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <section class="bg-light">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12 col-md-12">
                        <div class="filter_search_opt">
                            <router-link to="" @click="show = !show" class="btn btn-dark full-width mb-4">{{ $t('Dashboard Navigation') }}<i class="fa-solid fa-bars ms-2 px-2"></i></router-link>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <UserSidebar :open="show" @update:open="show = $event" :userData="userData" :category-name="categoryName" :state-name="stateName"/>
                    </div>    
                    <div class="col-lg-9 col-md-12">
                        <div class="dashboard-wraper">
                            <form @submit.prevent="submitUserForm">
                                <div class="row">
                                <div class="col-lg-6 col-md-6 mb-3">
                                    <label class="mb-1">{{ $t('Full Name') }}</label><span class="text-danger">*</span>
                                    <input type="text" class="form-control" v-model="form.name" :placeholder="$t('Full Name')" />
                                    <small class="text-danger" v-if="errors.name">{{ errors.name[0] }}</small>
                                </div>

                                <div class="col-lg-6 col-md-6 mb-3">
                                    <label class="mb-1">{{ $t('Email') }}</label><span class="text-danger">*</span>
                                    <input type="email" class="form-control" v-model="form.email" :placeholder="$t('Your Email')" />
                                    <small class="text-danger" v-if="errors.email">{{ errors.email[0] }}</small>
                                </div>
                                </div>

                                <div class="row">
                                <div class="col-lg-6 col-md-6 mb-3">
                                    <label class="mb-1">{{ $t('Phone') }}</label><span class="text-danger">*</span>
                                    <div>
                                      <input type="tel" class="form-control" name="phone" id="phone" :placeholder="$t('Phone')" />
                                    </div>
                                    <small class="text-danger" v-if="errors.phone">{{ errors.phone[0] }}</small>
                                </div>

                                <div class="col-lg-6 col-md-6 mb-3">
                                    <label class="mb-1">{{ $t('State') }}</label>
                                    <select class="form-control" v-model="form.state">
                                        <option value="" disabled>{{ $t('Select State') }}</option>
                                        <option v-for="state in states" :key="state.value" :value="state.value">
                                            {{ state.label }}
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="errors.state">{{ errors.state[0] }}</small>
                                </div>
                                </div>
                                <div class="row">
                                <!-- <div class="col-lg-6 col-md-6 mb-3">
                                    <label class="mb-1">{{ $t('Password') }}</label>
                                    <input type="password" class="form-control" v-model="form.password" placeholder="*******" />
                                    <small class="text-danger" v-if="errors.password">{{ errors.password[0] }}</small>
                                </div> -->
                                <div class="col-lg-6 col-md-6 mb-3">
                                <label class="mb-1">{{ $t('Area') }}</label>
                                <select class="form-control" v-model="form.city">
                                    <option value="" disabled>{{ $t('Select Area') }}</option>
                                    <option v-for="city in cities" :key="city.value" :value="city.value">
                                    {{ city.label }}
                                    </option>
                                </select>
                                <small class="text-danger" v-if="errors.city">{{ errors.city[0] }}</small>
                                </div>
                                <div class="col-lg-6 col-md-6 mb-3">
                                    <label class="mb-1">{{ $t('Category') }}</label>
                                    <select class="form-control" v-model="form.categories" multiple>
                                        <option value="" disabled>{{ $t('Select Category') }}</option>
                                        <option v-for="category in categories" :key="category.value" :value="category.value">
                                            {{ category.label }}
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="errors.categories">{{ errors.categories[0] }}</small>
                                </div>
                                </div>

                                <div class="form-group">
                                <button type="submit" class="btn btn-primary full-width fw-medium">
                                    {{ $t('Update') }}
                                    <i class="fa-solid px-2" :class="$i18n.locale === 'ar' ? 'fa-arrow-left-long' : 'fa-arrow-right-long'"></i>
                                </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <FooterTop :bg="'theme-bg'"/>

        <FooterDark/>

        <ScrollToTop/>

    </div>
</template>

<script setup>
import { ref,computed,watch,onMounted } from 'vue'
import axios from 'axios';
import {useI18n} from "vue-i18n";
import { useToast } from "vue-toastification"
import UserSidebar from '@/components/user_sidebar.vue';
import AdminNavbar from '@/components/navbar/admin-navbar.vue';
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
const iti =ref({})
const toast = useToast()
const { t, locale } = useI18n()
const token = localStorage.getItem('auth_token');
const userData = ref(null);
const categoryName = computed(() => {
  const categories = userData.value?.user_details?.preferredCategories;
  if (!Array.isArray(categories) || categories.length === 0) return '';
  return categories[0].name;
});
const stateName = computed(() => {
    if (!userData.value?.user_details?.state) return '';        
    return userData.value.user_details.state.name;
}); 
// axios.get('/users/normal-user/show-details', {
// headers: {
//     Authorization: `Bearer ${token}`,
//     Accept: 'application/json'
// },
// })
// .then(response => {
// const data = response.data.user_details;
// userData.value = response.data;

// form.value.name = data.name || '';
// form.value.email = data.email || '';
// form.value.phone = data.phone || '';
// form.value.state = data.state?.id || '';
// form.value.categories = data.preferredCategories?.map(cat => cat.id) || [];
// })
// .catch(error => {
// console.error("Axios error:", error);
// });
const errors = ref({})
const cities = ref([])
const form = ref({
  name: '',
  email: '',
  phone: '',
  password: '',
  state: '',
  city: '',
  categories: [],
})
const fetchCities = async (stateId) => {
  if (!stateId) {
    cities.value = []
    form.value.city = ''
    return
  }

  try {
    const response = await axios.get(`/get-cities/${stateId}`,{
      headers:{
        locale:locale.value
      }
    })
    const fetchedCities = response.data.cities || []
    cities.value = fetchedCities.map(city => ({
      label: city.name,
      value: city.id
    }))
    form.value.city = ''
  } catch (error) {
    console.error("Error fetching cities:", error)
    cities.value = []
  }
}
watch(() => form.value.state, (newState) => {
  fetchCities(newState)
})


const submitUserForm = async () => {
  errors.value = {}
  let formValid = true;

  // const phoneRegex = /^\+?[0-9]{10,15}$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const requiredFields = [ 'email','name'];
  requiredFields.forEach((field) => {
    if (!form.value[field] || (Array.isArray(form.value[field]) && form.value[field].length === 0)) {
      errors.value[field] = [
        t('validation.required', { field: t(`fields.${field}`) })
      ];
      formValid = false;
    }
  });

  const phoneNumber = iti.value.getNumber();

  if (!phoneNumber || phoneNumber.trim() === '') {
    errors.value.phone = [t('validation.required', { field: t('fields.phone') })];
    // console.log("1");
    formValid = false;
  } else if (!iti.value.isValidNumber()) {
    // console.log("hello");
    
    errors.value.phone = [t('validation.invalid_phone')];
    formValid = false;
  } else {
    
    form.value.phone = phoneNumber;
    // console.log(form.value.phone);
  }

  if (form.value.email && !emailRegex.test(form.value.email)) {
    errors.value.email = [t('validation.invalid_email')];
    formValid = false;
  }

  if (!formValid) return; 

  try {
    const res = await axios.post('/users/normal-user/update', {
      name: form.value.name,
      email: form.value.email,
      phone: form.value.phone,
      password: form.value.password,
      state_id: form.value.state,
      city_id: form.value.city,
      categories: form.value.categories,
    },
    {
        headers: {
        Authorization: `Bearer ${token}`,
        },
    }

    );
    console.log('User updated:', res.data);
    toast.success(t('Your Account Updated Successfully.'))
    console.log('User updated:', res.data);
    window.location.reload()
    form.value = {
      name: '',
      email: '',
      phone: '',
      password: '',
      state: null,
      categories: []
    };
    errors.value = {};
  } catch (error) {
    if (error.response && error.response.status === 422) {
      errors.value = error.response.data || {};
      const msg = Object.values(errors.value).flat().join('\n');
      toast.error(msg);
    } else {
      toast.error(t('An unexpected error occurred. Please try again.'));
    }
  }
}
const states = ref([]);
const categories = ref([]);
const loading = ref(false)
const fetchStates = async () => {
loading.value = true;
try {
    const response = await axios.get(`/get-states`,{
      headers:{
        locale:locale.value
      }
    });
    const fetchedStates = response.data.states || [];
    states.value = fetchedStates.map(state => ({
    label: state.name,
    value: state.id
    }));
} catch (error) {
    console.error("Error fetching states:", error);
} finally {
    loading.value = false;
}
};
const fetchCategories = async () => {
loading.value = true;
try {
    const response = await axios.get(`/get-categories`, {
        headers: {
            'locale': locale.value
        }
    });
    const fetchedCategories = response.data.categories || [];
    categories.value = fetchedCategories.map(category => ({
    label: category.name,
    value: category.id
    }));
} catch (error) {
    console.error("Error fetching categories:", error);
} finally {
    loading.value = false;
}
};
watch(locale, fetchStates, { immediate: true });
watch(locale, fetchCategories, { immediate: true });
onMounted(() => {
  const input = document.querySelector("#phone");
  iti.value = intlTelInput(input, {
    initialCountry: "auto",
    nationalMode: false,
    separateDialCode: true,
    loadUtils: () => import("intl-tel-input/utils"),
    geoIpLookup: (callback) => {
      fetch("https://ipapi.co/json")
        .then((res) => res.json())
        .then((data) => callback(data.country_code.toLowerCase()))
        .catch(() => callback("us"));
    }
  });

  axios.get('/users/normal-user/show-details', {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }
  }).then(response => {
    const data = response.data.user_details;
    userData.value = response.data;

    form.value.name = data.name || '';
    form.value.email = data.email || '';
    form.value.state = data.state?.id || '';
    form.value.categories = data.preferredCategories?.map(cat => cat.id) || [];

    if (data.phone) {
      iti.value.setNumber(data.phone);

    }
  }).catch(error => {
    console.error("Axios error:", error);
  });

  input.addEventListener("countrychange", () => {
    const country = iti.value.getSelectedCountryData();
    console.log("Detected country:", country.name, country.iso2);
  });
});



</script>
<style>
.iti {
  --iti-path-flags-1x: url('/node_modules/intl-tel-input/build/img/flags.webp');
  --iti-path-flags-2x: url('/node_modules/intl-tel-input/build/img/flags@2x.webp');
  --iti-path-globe-1x: url('/node_modules/intl-tel-input/build/img/globe.webp');
  --iti-path-globe-2x: url('/node_modules/intl-tel-input/build/img/globe@2x.webp');
}
.iti input.iti__tel-input, .iti input.iti__tel-input[type=text], .iti input.iti__tel-input[type=tel]
{
  position: relative;
  z-index: 0;
  margin: 0 !important;
  width: 337px;
}
[dir="ltr"] .iti input.iti__tel-input {
text-align: left;
}

[dir="rtl"] .iti input.iti__tel-input {
  text-align: right;
}
</style>
<style scoped>
.d-flex.gap-2 {
  align-items: center;
}
</style>